export const USERLOGINFETCH = "USERLOGINFETCH";
export const USERLOGINSUCCESS = "USERLOGINSUCCESS";
export const USERLOGINFAILED = "USERLOGINFAILED";
export const USERLOGININFO = "USERLOGININFO";
export const USERLOGOUT = "USERLOGOUT";
export const USERUPDATECOMPANY = "USERUPDATECOMPANY";

export const LOADACTION = "LOADACTION";
export const LOADEDACTION = "LOADEDACTION";
export const TOGGLE_MODAL_PROFILE = "TOGGLE_MODAL_PROFILE";
export const TOGGLE_MODAL_COMPANY = "TOGGLE_MODAL_COMPANY";
